import { AppBar, Grid2, Toolbar, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import metrolinxWhiteLogo from "../Assets/Metrolinx_White_Logo.png";
import "./styles/footer.scss";

const Footer: React.FC = () => {
  const [isContentLong, setIsContentLong] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const currentHeight = window.innerHeight;
      const pageHeight = document.body.scrollHeight;
      setIsContentLong(pageHeight > currentHeight);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { t } = useTranslation();

  const sxProps = {
    mainAppBar: {
      position: isContentLong ? "relative" : "fixed",
      bottom: 0,
      left: 0,
      backgroundColor: "#000000",
      height: "100px",
      borderTop: "3px solid #72b34b",
      width: "100%",
      zIndex: 999,
      padding: "0 12px",
      "@media (max-width: 600px)": {
        paddingBottom: "8px",
      },
    },
    footerMargin: {
      marginBottom: isContentLong ? "0px" : "100px",
      "@media (max-width: 600px)": {
        marginBottom: "0",
      },
    },
    bar1: {
      display: "flex",
      width: "18%",
      backgroundColor: "#000000",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "5px",
      "@media (max-width: 600px)": {
        width: "31%",
        justifyContent: "flex-end",
        marginLeft: "15px",
        marginRight: "0%",
        gap: "4px",
      },
    },
    bar2: {
      display: "flex",
      alignItems: "center",
      width: "50%",
      marginTop: "0",
      justifyContent: "flex-start",
      "@media (max-width: 600px)": {
        width: "50%",
        justifyContent: "flex-start",
        marginLeft: "-10px",
      },
    },
    typo2: {
      color: "#fff",
      fontSize: "10px",
      fontWeight: "500",
      fontFamily: "AvenirNextProMedium, Arial",
      marginLeft: "25px",
      "@media (max-width: 600px)": {
        fontSize: "9px",
      },
    },
  };

  return (
    <Grid2 container sx={sxProps.footerMargin}>
      <AppBar position="static" sx={sxProps.mainAppBar}>
        <Toolbar>
          <Grid2 container sx={{ display: "flex", width: "100%" }}>
            <Grid2 sx={sxProps.bar1}>
              <img
                className="metrox-logo"
                src={metrolinxWhiteLogo}
                alt="Metrolinx White Logo"
              />
            </Grid2>
            <Grid2 sx={sxProps.bar2}>
              <Typography
                sx={sxProps.typo2}
                aria-label="Metrolinx and Presto Text"
              >
                &#169;&nbsp;{process.env.REACT_APP_CURRENT_YEAR}
                {t(" Metrolinx | Presto")}
              </Typography>
            </Grid2>
          </Grid2>
        </Toolbar>
      </AppBar>
    </Grid2>
  );
};

export default Footer;
